import Styles from './CoursesCard.module.scss'
import { LinearProgress, Chip } from '@mui/material';
import { Tooltip as ReactTooltip } from "react-tooltip";


export function CoursesCard({ data, onClick, isArchivePage = false }) {
    const disableClick = !isArchivePage && data?.status !== "published"
    const dueDate = data?.due_date ? new Date(data.due_date).toLocaleDateString() : null;
    const mediaUrl = data?.is_custom_image === 1
        ? process.env.REACT_APP_AZURE_STORAGE_MEDIA_URL
        : process.env.REACT_APP_GLOBAL_MEDIA_URL;

    return (<>

        <div
            data-tooltip-id={data?.tagNames && "course_card"}
            className={Styles.mainContainer_card}
            data-tooltip-content={data?.tagNames}
            data-some-relevant-attr={data.id}
            onClick={onClick}
            style={{
                opacity: disableClick ? "0.5" : "1",
                pointerEvents: disableClick ? "none" : ""
            }}
        >
            <div className={Styles.imgContainer}>
                <img src={`${mediaUrl}${data?.icon}`} alt={`icon`} />
            </div>
            {(data?.completion_percentage && data?.completion_percentage !== 0) ?
                <>
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '0.3em' }}>
                        <LinearProgress
                            variant="determinate"
                            // value={parseInt(data?.completion_percentage)}
                            value={data?.completion_percentage}

                            className={Styles.progessBar}
                            sx={{
                                backgroundColor: "#6382702e",
                                "& .MuiLinearProgress-bar": {
                                    backgroundColor: "#008037",
                                },
                            }}
                        />
                        <p style={{ fontSize: '0.5em', fontWeight: 600 }}>{data?.completion_percentage}%</p>
                    </div>
                    <Chip sx={{ minHeight: '2em', maxHeight: '2em' }} label={`Score: ${data?.score}`} />
                </>
                : data?.completion_status ?
                    (
                        <>
                            <Chip sx={{ minHeight: '2em', maxHeight: '2em' }} label={data?.completion_status} variant="outlined" />
                        </>
                    ) : (
                        <Chip
                            sx={{ minHeight: '2em', maxHeight: '2em' }}
                            label={isArchivePage ? data?.status?.toUpperCase()
                                : data?.level?.toUpperCase() !== "N/A" ? data?.level?.toUpperCase() : "Open"}
                        />
                    )
            }
            <span className={Styles.titleAndDesc}>
                <p className={Styles.courseName}>{data?.title}</p>
                {dueDate && <p className={Styles.dueDate}>Due Date: {dueDate}</p>}
                <p className={Styles.courseDescr}>{data?.desc}</p>
            </span>
        </div>
        <ReactTooltip id="course_card" className={Styles.toolTip} place='right' style={{ backgroundColor: "#fff", color: "#222", boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}
            render={({ content, activeAnchor }) => (
                < div className={Styles.tooltipMain}>
                    <p className={Styles.infoTitle}>Skills you'll learn</p>
                    {content?.length > 0 &&
                        <div className={Styles.tagsContainer}>
                            {content.split(',')?.map((tag, index) =>
                            (
                                <span key={`${index}-${tag}`}>
                                    <Chip
                                        label={tag}
                                        size="small"
                                    />
                                </span>
                            )
                            )}
                        </div>
                    }
                </div>
            )} />
    </>
    )
}
